export const APP_NAME = 'smartbar';
export const BASE_URL = 'https://sb.udtech.global';
export const API_URL = 'https://sb.udtech.global';



// WEBPACK FOOTER //
// ./src/utils/const.js